import React from 'react';
import styled from 'styled-components';
import OpenPageBase from 'Common/pages/OpenPageBase';
import { FormattedMessage } from 'react-intl';
import { Row, Button, Space } from 'antd';

import ForgotPasswordContainer from '../components/ForgotPassword';

const Title = styled.h1`
  font-size: 24px;
`;

const ContentWrapper = styled.div`
  background: #fff;
  padding: 50px;
`;

const ForgotPassword = () => (
  <OpenPageBase>
    <Row css="height: 100%" justify="center" align="middle">
      <ContentWrapper>
        <Space orientation="vertical" css="width: 100%">
          <Title>
            <FormattedMessage defaultMessage="Forgot your password?" />
          </Title>
          <ForgotPasswordContainer />
          <div css="text-align: center">
            <FormattedMessage
              defaultMessage="Already have an account? <link>Sign in</link>"
              values={{
                link: (chunk: React.ReactNode) => (
                  <Button css="padding: 0" href="/login" type="link">
                    {chunk}
                  </Button>
                ),
              }}
            />
          </div>
        </Space>
      </ContentWrapper>
    </Row>
  </OpenPageBase>
);

export default ForgotPassword;
